import {api} from './api';

const API_BASE = '/api/v1/agents/routing-configs';

export interface AgentTriggerConfig {
    id?: number;
    agentConfigId?: number;
    triggerKind?: string;
    eventType?: string;
    messageType?: string;
    priority?: number;
    description?: string;
    isActive?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface AgentOutputConfig {
    id?: number;
    agentConfigId?: number;
    messageType: string;
    outputKind?: string;
    targetAgentConfigId?: number;
    description?: string;
    isActive?: number;
    createdAt?: string;
    updatedAt?: string;
}

class AgentRoutingConfigService {
    async getAllTriggers(): Promise<AgentTriggerConfig[]> {
        const rsp = await api.get(`${API_BASE}/triggers`);
        return rsp.data.data;
    }

    async getAllOutputs(): Promise<AgentOutputConfig[]> {
        const rsp = await api.get(`${API_BASE}/outputs`);
        return rsp.data.data;
    }

    async refreshCache(): Promise<void> {
        await api.post(`${API_BASE}/refresh-cache`);
    }
}

export const agentRoutingConfigService = new AgentRoutingConfigService();
